import Entity from "./entity";
import ProjectMember from "./project-member";
import ProjectTeam from "./project-team";
import ProjectInvitation from "./project-invitation";

export default class Project extends Entity<string> {
  name: string;
  color: string;
  completedPercentage: number;
  boardData: string;
  boardDataVersion: number;
  hashTags: string;
  description: string;
  archived: boolean;
  members: ProjectMember[];
  teams: ProjectTeam[];
  invitations: ProjectInvitation[];
  grantedPermissions;
}
